import { addToOrder } from "./addToOrder";

export const actions = {
    addToOrder,
};
